// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"13":"60e3b3ff","36":"29719475","163":"984c2230","752":"12d0bd4b","779":"737fad94","788":"b42c4996","964":"92b4c693"}[chunkId] + ".css";
};